import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './InlineEdit.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "content-editable-wrapper",
      attrs: { editing: _vm.isEditing }
    },
    [
      _c(
        "div",
        {
          ref: "text-field",
          staticClass: "content-editable",
          attrs: { compact: _vm.compact, "is-invalid": !!_vm.error }
        },
        [
          _vm.isEditing
            ? _vm._t(
                "editor",
                [
                  _c(
                    "TextField",
                    {
                      style: { minWidth: _vm.contentWidth + "px" },
                      attrs: {
                        "is-focused": _vm.isFocused,
                        "is-invalid": !!_vm.error,
                        "is-loading": _vm.isLoading,
                        "is-disabled": _vm.isLoading,
                        compact: _vm.compact
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation();
                        },
                        "hook:beforeMount": _vm.beforeTextFieldMount
                      }
                    },
                    [
                      _vm.type === "checkbox"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.editingValue,
                                expression: "editingValue"
                              }
                            ],
                            ref: "input",
                            staticClass: "input",
                            attrs: {
                              step: _vm.step,
                              maxlength: _vm.maxlength,
                              disabled: _vm.isLoading,
                              align: _vm.align,
                              type: "checkbox"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.editingValue)
                                ? _vm._i(_vm.editingValue, null) > -1
                                : _vm.editingValue
                            },
                            on: {
                              keyup: _vm.onKeyUp,
                              keydown: [
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  if (!$event.metaKey) {
                                    return null
                                  }
                                  return _vm.onKeyUp($event)
                                },
                                function($event) {
                                  if (
                                    $event.ctrlKey ||
                                    $event.shiftKey ||
                                    $event.altKey ||
                                    $event.metaKey
                                  ) {
                                    return null
                                  }
                                  return _vm.validate($event)
                                }
                              ],
                              focus: _vm.onFocus,
                              blur: _vm.onBlur,
                              change: function($event) {
                                var $$a = _vm.editingValue,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false;
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v);
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.editingValue = $$a.concat([$$v]));
                                  } else {
                                    $$i > -1 &&
                                      (_vm.editingValue = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)));
                                  }
                                } else {
                                  _vm.editingValue = $$c;
                                }
                              }
                            }
                          })
                        : _vm.type === "radio"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.editingValue,
                                expression: "editingValue"
                              }
                            ],
                            ref: "input",
                            staticClass: "input",
                            attrs: {
                              step: _vm.step,
                              maxlength: _vm.maxlength,
                              disabled: _vm.isLoading,
                              align: _vm.align,
                              type: "radio"
                            },
                            domProps: {
                              checked: _vm._q(_vm.editingValue, null)
                            },
                            on: {
                              keyup: _vm.onKeyUp,
                              keydown: [
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  if (!$event.metaKey) {
                                    return null
                                  }
                                  return _vm.onKeyUp($event)
                                },
                                function($event) {
                                  if (
                                    $event.ctrlKey ||
                                    $event.shiftKey ||
                                    $event.altKey ||
                                    $event.metaKey
                                  ) {
                                    return null
                                  }
                                  return _vm.validate($event)
                                }
                              ],
                              focus: _vm.onFocus,
                              blur: _vm.onBlur,
                              change: function($event) {
                                _vm.editingValue = null;
                              }
                            }
                          })
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.editingValue,
                                expression: "editingValue"
                              }
                            ],
                            ref: "input",
                            staticClass: "input",
                            attrs: {
                              step: _vm.step,
                              maxlength: _vm.maxlength,
                              disabled: _vm.isLoading,
                              align: _vm.align,
                              type: _vm.type
                            },
                            domProps: { value: _vm.editingValue },
                            on: {
                              keyup: _vm.onKeyUp,
                              keydown: [
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  if (!$event.metaKey) {
                                    return null
                                  }
                                  return _vm.onKeyUp($event)
                                },
                                function($event) {
                                  if (
                                    $event.ctrlKey ||
                                    $event.shiftKey ||
                                    $event.altKey ||
                                    $event.metaKey
                                  ) {
                                    return null
                                  }
                                  return _vm.validate($event)
                                }
                              ],
                              focus: _vm.onFocus,
                              blur: _vm.onBlur,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.editingValue = $event.target.value;
                              }
                            }
                          })
                    ]
                  )
                ],
                {
                  value: _vm.editingValue,
                  input: _vm.onInput,
                  blur: _vm.onBlur,
                  focus: _vm.onFocus,
                  confirm: _vm.confirmEditedValue,
                  cancel: _vm.cancelInlineEdit,
                  isFocused: _vm.isFocused,
                  isInvalid: !!_vm.error,
                  isLoading: _vm.isLoading,
                  contentWidth: _vm.contentWidth,
                  contentHeight: _vm.contentHeight
                }
              )
            : _c(
                "InlineEditViewContent",
                {
                  ref: "value",
                  attrs: {
                    compact: _vm.compact,
                    icon: _vm.icon,
                    align: _vm.align
                  },
                  on: { "edit-requested": _vm.onEditRequested }
                },
                [_vm._t("default")],
                2
              )
        ],
        2
      ),
      _vm._v(" "),
      _vm.isEditing && !_vm.isLoading && _vm.confirm
        ? _c(
            "Popper",
            {
              ref: "buttons",
              attrs: {
                offset: _vm.offset,
                "target-element": _vm.$refs["text-field"]
              }
            },
            [
              _c("InlineEditButtons", {
                on: {
                  confirm: _vm.confirmEditedValue,
                  cancel: _vm.cancelInlineEdit,
                  blur: _vm.onBlur
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isValidationError
        ? _c("InlineErrorMessage", {
            attrs: {
              error: _vm.error,
              "target-element": _vm.$refs["text-field"],
              placement: _vm.placement
            }
          })
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-111c20ba";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Form/InlineEdit.vue.js